export default "__VITE_ASSET__2GjCUOfv__"